export default __webpack_public_path__ + "static/media/gear-blue.dbaac633.svg";